export const PERMS = {
    //GENERAL
    "CREATE": "8609dc06-4097-4bc6-8cb7-7541859300e6",
    "READ": "0020368c-15b0-451c-d3bd-0ea2832b9eec",
    "UPDATE": "d4824769-cfce-a51c-ab96-bccba0406bfb",
    "DELETE": "f25d64d1-a7ac-42fa-b3d2-194c6bf1c121",
    
    
    
    //HMIS
    "HMIS": "5a9665b2-dca7-4b43-bc40-28ff44428fcb",
    "CAN_VIEW_REDEPTION_REPORT": "243ea215-4b17-11ee-8650-0a9ea65235cc",


    // Surveys
    "SURVEYS": "472e15e2-d569-41f7-b6c3-af6b812e74e8",
    "LIST_SURVEYS": "08b8734d-fad3-4d4d-a11c-7092a3a3d0d6",
    "CREATE_SURVEYS": "9a4db204-ab01-4141-8929-bca3765002f8",
    "UPDATE_SURVEYS": "f0a80ccb-7c5d-48ab-b101-b33bf5429d47",

   // Projects
    "PROJECTS": "2d95a9a9-291f-43f6-b1ff-7a90b206a8a5",
    "LIST_PROJECTS": "fd39af80-ccd8-4a0e-b52c-8d48f01d4d5e",
    "CREATE_PROJECT": "9023ef1a-2888-4d8b-8f4c-79fb58f78380",
    "UPDATE_PROJECT": "3923e1a2-9219-4362-b652-30e6ce215030",
    "UPDATE_BENEFICIARY": "faa68c4e-cfb4-4689-b77d-b0614e2765af",
    "CAN_UPDATE_SRF_FORM": "59d7a686-7de5-492d-9868-9da6cb82689e",
    "CAN_SEARCH_BENEFICIARY_BY_TELEPHONE": "d4f90114-4e15-406d-8893-17b4b146de20",
    "CAN_VERIFY_BENEFICIARIES_AS_MEAL_OFFICER": "b7044e18-4acd-4836-8e51-8af6f6178619",
    "CAN_UPDATE_BENEFICIARY_LOCATION_DETAILS": "6880d4ad-4d8b-4482-9c79-8ad3bad82536",
    "DELETE_BENEFICIARY": "8c988421-a928-4b72-b9e4-07d3bd893c45",
     
    "VIEW_BNF_MAP": "f69797f1-0153-41c8-a132-d729f0b7afb5",
    "GENERATE_MASTER_LIST": "9657e8c8-ce04-4de9-9fc4-38a3f2e08810",
    "MANAGE_COMPONENTS": "9ad8a1d2-1b16-4277-b412-9f1cac45cfc5",
    "CAN_UPDATE_COMPONENT_PROJECT": "40fcbc23-8ba9-400d-be13-a47604936c0a",
    "EXPORT_SNAPSHOT": "af82787c-eefa-4803-8ab3-d57318041370",
    "CAN_CLONE_BENEFICIARIES": "a4095c6d-fd1a-45c7-92cd-7d074f2fd9d5",
    "CAN_VIEW_PROJECT_MAPPING_LISTING": "ced2e9d4-bebd-41a4-80a6-98661069c478",
    "CAN_UPLOAD_PROJECT_MAPPINGS": "65bf7eed-4b86-431d-af1c-b88cce986ee2",
    "CAN_UPLOAD_BENEFICIARY_RECORDS": "0f9c1471-d06e-40d5-81c9-6f51b2d31876",
    "CAN_UPLOAD_CVA_RECORDS": "937399a3-7aab-4df3-ae04-10e0adb70bd6",
    "LIST_WASH_PROJECTS": "e5c53101-7bf9-43de-9065-74cf7501673f",
    "CREATE_WASH_PROJECT": "9023ef1a-2888-4d8b-8f4c-79fb58f78380",
    "UPDATE_WASH_PROJECT": "3923e1a2-9219-4362-b652-30e6ce215030",






    //HRM
    "HRM": "3714955c-3673-4d98-9ce1-423c171ec592",
    "LIST_EMPLOYEES": "7e7560ed-39ef-44af-8cd4-61d8ea495813",
    "UPLOAD_DESIGNATIONS": "b52fd861-07d9-4f03-b4b0-f4ecc43ec962",
    "UPLOAD_OFFICES": "5354aebd-e5fa-4567-8d0e-eb4974ef8f9b",
    "UPLOAD_EMPLOYEES": "15a2de98-2356-42f9-8339-184f66626603",
    "LIST_PAYROLL_SETUPS": "24eaea11-654a-4d28-82a3-e2e03a0cfc86",
    "CREATE_BUDGET_ALLOCATIONS": "0d511bee-8e59-4f88-b88a-16e77d4bf80c",
    "CAN_VIEW_COMPLETED_PAYROLL": "31d844f5-7368-4fd9-8ae5-d89801e74ade",
    "CAN_CREATE_BUDGET_CODES": "29667bbe-3831-43a4-986a-2be5f8963beb",
    "CAN_PROCESS_PAYROLL": "96d34314-ae4a-4d15-8068-61b1d37b913a",
    "CAN_UPDATE_PAYROLL": "4f2a29cb-2fb8-4f8a-96aa-7809b6264044",
    "CAN_VIEW_STAFF_ATTENDANCE": "6e3ab00a-0e08-488f-bf15-aed7f29e02c1",
    "CAN_ASSIGN_STAFF_ALLOWANCE": "bceb3504-22b2-4276-93de-06ee1fdf5415",
    "CAN_ASSIGN_STAFF_TAX": "d7b12f23-7ffa-4cf3-afad-d78473a6508e",
    "CAN_ASSIGN_STAFF_TAGS": "67ad4550-c10e-4871-88a9-711e243dd6ff",
    "CAN_CREATE_LEAVE": "7fa6b4e3-f5e7-498c-9567-bb901202e623",
    "CAN_VIEW_MY_LEAVE_REQUESTS": "051651fd-9855-4c88-9937-715ca9584ba0",
    "CAN_VIEW_ALL_LEAVE_REQUESTS_REPORT": "3ece304e-45d8-497e-81cb-4d6b1d9f6be3",
    "CAN_VIEW_PENDING_LEAVE_ACTIONS": "a6addd8d-cfd5-4733-a59e-65da89df5679",
    "CAN_UPDATE_LEAVE_APPROVER": "ceb10a16-3284-4aed-bc7e-8225b2373ffc",
    "CAN_VIEW_LEAVE_BALANCE_REPORT": "7a489110-1861-49e4-9824-2c72813968d3",
    "CAN_VIEW_PENDING_ADVANCE_REQUESTS": "cfca0fc2-e816-4943-a445-6a25604d1e09",
    "CAN_VIEW_PAYROLL_SUMMARY": "8dc288ee-676d-4a53-83eb-84721b7a19d6",
    "CAN_VIEW_BUDGET_ALLOCATIONS_REPORT": "7fd55666-d165-4eae-910a-c8b0f39c4acc",
    "CAN_DOWNLOAD_PAYSLIPS": "8b252061-8dc8-4f62-8fdd-77ce3bb39f04",
    "LIST_PAYROLLS": "8c3cbe6f-ecfe-4e29-9f70-c7a0006b0d55",
    "CREATE_BANK_ACCOUNT": "fd5579cb-46c6-4f66-825e-27a84acbfbf3",
    "UPLOAD_BANK_ACCOUNTS": "a645ae28-ba51-4218-b33d-7490d75619af",
    "UPLOAD_BUDGET_ALLOCATIONS": "8ba51d6d-ecb7-426c-aa99-5ff42567d5ea",
    "LEAVE_REQUEST_REPORT": "3ece304e-45d8-497e-81cb-4d6b1d9f6be3",
    "CAN_ACCESS_STAFF_SCORING": "75d0c595-b834-4479-b33e-2b407fd6af6c",
    "CAN_ACCESS_STAFF_SCORING_RESULTS": "79408e34-53a9-4a72-b6ed-c6debd509418",
    "CAN_VIEW_STAFF_ID_CARD_DETAILS": "68e56556-427d-4334-be88-f68902aa1447",
    "CAN_ACCESS_CONTRACT_TRACKSHEET": "b6d86013-9cd9-43d3-963a-b6db4c6fe2f1",
    "CAN_DELETE_WORKFORCE_PLANNING": "a3f0ce7a-b5e7-4373-96a8-d3bc37410994",
    "CAN_CREATE_WORKFORCE_PLANNING": "e2bbdbca-a76a-4603-8f91-ca74a46e29c8",
    "CAN_VIEW_WORKFORCE_PLANNING_ANALYSIS": "a0eb295c-89c0-4fc2-acec-5280f1414a94",
    "CAN_UPDATE_CD_APPROVAL_WORKFORCE_PLANNING": "36656624-3086-4981-894a-19f75d4c3a23",
    "MANAGE_STAFF_ROLES": "9e238768-7578-4648-8c7e-2616a9a939f4",

   //ASSET MANAGEMENT

    "ASSET": "1bc3ea65-46bc-4c59-802a-98c70047d84c",
    "LIST_ASSETS": "8356b32f-af88-499e-bd1a-635fb8fbdf1d",
    "LIST_ASSET_CATEGORIES": "b14d5677-9e51-4b20-a33f-18672c5c766a",
    "CAN_VIEW_CARD_HISTORY": "ffed7fc7-8b01-4057-8a52-6aa8d8d4cd16",


    // ADMINSTRATION
    "MANAGE_PERMISSIONS": "c8c940c3-876b-4733-b1a0-25d220a5cf7f",
    "MANAGE_ACCESS": "023bee02-9eb1-4f2b-bdb9-fa55224cb860",
    "UPDATE_TEMPLATES": "9a4efe43-b83f-46cb-8bae-493957870bbc",
    "MANAGE_USERS": "2d0d6e89-17fc-4005-aa00-70b763010d21",
    "MANAGE_WORKFLOWS": "43f41a84-10f7-48c1-a14c-71f5d7164d2b",



};